import React, { FC } from "react";
import { Trash2, TriangleAlert } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface DeleteConfirmationDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title?: string;
  content?: string;
}

/**
 * shadcn version of the shared `DeleteConfirmationDialog` (originally MUI). Uses a
 * shadcn AlertDialog (a confirmation, not a form) with the same props/behaviour.
 * Styled to match the V2 billing dialogs (title icon + description + accent buttons).
 * Used only by `NewPatientRechnungTableV2`.
 */
const DeleteConfirmationDialogShad: FC<DeleteConfirmationDialogProps> = ({
  open,
  onCancel,
  onConfirm,
  title = "Aus der Liste entfernen?",
  content = "",
}) => {
  return (
    <AlertDialog open={open} onOpenChange={(next) => !next && onCancel()}>
      <AlertDialogContent className="sm:max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-xl">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-red-100 text-red-600">
              <TriangleAlert className="h-5 w-5" />
            </span>
            {title}
          </AlertDialogTitle>
          {content ? (
            <AlertDialogDescription className="text-[15px]">{content}</AlertDialogDescription>
          ) : null}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="text-base" onClick={onCancel}>
            Abbrechen
          </AlertDialogCancel>
          <AlertDialogAction
            className="gap-2 bg-red-600 text-base text-white hover:bg-red-700 [&_svg]:size-4"
            onClick={onConfirm}
          >
            <Trash2 />
            Ja, Entfernen
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteConfirmationDialogShad;
